import { put, call, delay } from 'redux-saga/effects';
import { Types } from './actions';
import ProceduresRepository from '../../../repositories/ProceduresRepository';
import ProceduresDataRepository from '../../../../data/repositories/ProceduresDataRepository';
import config from '../../../../core/config/config';

export default function* execute(action: any): any {
  try {
    yield put({ type: Types.GET_MODALITY_OPTION_LIST_REQUEST });
    const procedureRepository: ProceduresRepository =
      new ProceduresDataRepository();
    const procedureResponse = yield call(
      procedureRepository.getModalityOptionList,
      action.campus,
      action.periodId
    );

    if (config.DATASOURCE_ENV === 'MOCK') yield delay(1000);

    if (!procedureResponse) {
      yield put({
        type: Types.GET_MODALITY_OPTION_LIST_FAILURE,
        error: 'No se pudo leer los datos del trámite.'
      });
      return;
    }

    yield put({
      type: Types.GET_MODALITY_OPTION_LIST_SUCCESS,
      data: procedureResponse
    });
  } catch (error) {
    yield put({
      type: Types.GET_MODALITY_OPTION_LIST_FAILURE,
      error:
        'Ocurrió un error al momento de leer los datos del trámite solicitado.'
    });
  }
}
